/*
 *   File : external-fund-import.js
 *   Author : https://evoqins.com
 *   Description : External fund import - refresh modal
 *   Integrations : NA
 *   Version : 1.0.0
 *   Date : 11-07-2024
*/


import { memo, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

// Components
import { PrimaryButton, } from "../Buttons";
import { SixDigitOTPInput } from "../Form-Elements";
import { APIService } from "../../Service";

//Assets
import ImportPortfolioSuccess from "../../Assets/Images/Orders/success.svg";
import CloseBtn from "../../Assets/Images/close-btn.svg";
import Loader from "../../Assets/Images/loader-blue.gif";


function ExternalFundImportModal(props) {

    const userData = useSelector((store) => store.Reducer.USER_DATA);
    const otpInputRef = useRef(null);

    const [focusedInput, setFocusedInput] = useState(1);
    const [otpValue, setOtpValue] = useState("");
    const [otpError, setOtpError] = useState("");
    const [timer, setTimer] = useState(30);
    const [loading, setLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [disableResendOTP, setDisableResendOTP] = useState(false); // for Resend OTP
    const [importSuccess, setImportSuccess] = useState(false);

    const [externalImportAPIData, setExternalImportAPIData] = useState("");
    const [externalFundLoader, setExternalFundLoader] = useState(false);


    useEffect(() => {
        _sendOTP();
    }, [])

    //for otp timer
    useEffect(() => {
        if (timer > 0) {
            // Start the timer when requestOtpSuccess becomes true
            const countdown = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
            // Clear the timer when the component unmounts or when the timer reaches 0
            return () => {
                clearInterval(countdown);
            };
        }

    }, [timer]);


    //handle confirm otp
    const _handleChangeOTP = (value) => {
        setOtpValue(value);
        setOtpError("");
    };

    const _handleResendOTP = () => {
        setDisableResendOTP(true);
        _sendOTP("RESEND");
    };

    // handle verify otp
    const _handleValidateOTP = () => {

        if (otpValue.length === 0) {
            setOtpError("Please enter the OTP");
            return;
        } else if (otpValue.length !== 6) {
            setOtpError("Please enter the full OTP");
            return;
        };

        // btn loader
        setLoading(true);
        // API Call for invest in selected fund
        _verifyOTP();

    };

    // handle Navigate
    const _handleRefreshPortfolio = () => {
        props.onImportSuccess();
    };


    // ======= API CALLS ======= //
    // ========================= //

    // API to send OTP
    const _sendOTP = (type) => {

        let is_post = true;
        let url = 'mf-services/cas/initiate';
        let data = {
            "pan": userData.pan_full
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {

                setExternalImportAPIData(response.data);

                if (type == "RESEND") {
                    toast.dismiss();
                    toast.success("OTP sent successfully to mobile number", {
                        className: "e-toast",
                    });
                }

                setOtpValue("");
                setFocusedInput(2);
                setTimer(30);

            } else {
                toast.dismiss();
                toast.error(response.message, {
                    className: "e-toast",
                });
            };

            setLoading(false);
            setDisableResendOTP(false);

        });

    };

    // API to verify OTP
    const _verifyOTP = () => {
        setLoading(true);
        let is_post = true;
        let url = 'mf-services/cas/consent';
        let data = {
            "otp": otpValue,
            ...externalImportAPIData
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setExternalFundLoader(true);
                setLoading(false);

                if (props.refreshInvestment === true) {
                    _fetchPortfolio();
                } else {
                    setTimeout(() => {
                        _fetchPortfolio();
                    }, 15000);
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    className: "e-toast",
                });
                setLoading(false);
            };

        });
    };

    // Get fetch portfolio data
    const _fetchPortfolio = () => {

        let is_post = true;

        let url = 'mf-services/cas/get-statement';
        let data = {
            "req_id": externalImportAPIData.req_id,
            "client_ref_no": externalImportAPIData.client_ref_no
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setImportSuccess(true);
                setExternalFundLoader(false);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    className: "e-toast",
                });
            };

            setLoading(false);
            setExternalFundLoader(false);

        });
    };

    // =============================================== //
    // ============ Inline component ================= //

    const StatusLoader = () => {
        return (
            <div className={`w-100 h-100 position-fixed top-0 start-0 d-flex justify-content-center align-items-center z-3`}>
                {/* overlay */}
                <div className="overlay-background opacity-75"></div>
                <div className="bg-white e-border-radius-8 p-3 d-flex flex-column justify-content-center align-items-center z-index-99">
                    <img src={Loader}
                        height={28}
                        draggable="false"
                        alt='loader' />
                    <p className="e-font-14-res mb-0 mt-2 e-text-egyptian-blue  e-font-16 e-alt-font-poppins e-font-weight-600 line-height-24px">
                        Fetching your investments from MFCentral
                    </p>
                </div>
            </div>
        )
    };

    return (
        <div className="modal fade e-manage-modal"
            id="import-portfolio-modal"
            data-bs-backdrop="static"
            tabIndex="-1"
            aria-labelledby="EditPhoneModal"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable min-h90vh">
                {
                    importSuccess === false ?
                        <div className="modal-content e-bg-lotion e-border-radius-24 e-addbank-box-shadow">
                            <div className="modal-header justify-content-start e-gap-0-16 pt-4 pb-3 px-3 px-sm-4 border-0">

                                <h6 className='e-font-14-res mb-0 e-text-charleston-green e-font-18 e-alt-font-poppins e-font-weight-600 line-height-32px'>
                                    Verify OTP
                                </h6>

                                <img src={CloseBtn}
                                    id='close-import-modal'
                                    draggable={false}
                                    className='cursor-pointer ms-auto'
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    alt='close'
                                    onClick={props.onClose} />
                            </div>
                            <div className="modal-body pb-4 px-3 px-sm-4 pt-0">

                                {/* otp section */}
                                <div className='py-3 px-4 e-border-radius-16 e-bg-cultured'>
                                    <p className='mb-0 e-text-onyx e-font-16 e-alt-font-poppins e-font-weight-400 line-height-28px'>
                                        MF central will send a 6-digit Otp to your PAN-linked
                                        mobile number
                                    </p>
                                    <div className='pt-3'>
                                        <label className="e-font-14-res e-text-charleston-green e-font-14 e-alt-font-poppins e-font-weight-500 line-height-24px">
                                            Enter OTP*
                                        </label>
                                        <SixDigitOTPInput ref={otpInputRef}
                                            id="otp"
                                            value={otpValue}
                                            error={otpError}
                                            spellCheck="false"
                                            focused_input={focusedInput}
                                            onFocus={() => setFocusedInput(2)}
                                            onBlur={() => setFocusedInput(0)}
                                            onChange={_handleChangeOTP} />

                                        <div className='e-inline-flex flex-wrap e-font-weight-400 e-text-charleston-green gap-2 e-font-14 e-alt-font-poppins line-height-18px'>
                                            Didn't get the OTP?
                                            <button className={`${timer !== 0 ? "e-disable e-text-dark-liver" : "e-text-egyptian-blue"} px-0 d-flex gap-1 border-0 e-bg-transparent`}
                                                disabled={disableResendOTP}
                                                onClick={_handleResendOTP} >
                                                Resend OTP
                                                {timer !== 0 &&
                                                    <p className='mb-0 e-text-dark-liver e-alt-font-poppins'>
                                                        in {timer} {timer == 1 ? "second" : "seconds"}
                                                    </p>
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className='d-flex gap-3 padding-32px-top mt-auto mb-2'>
                                    <PrimaryButton name="Verify OTP"
                                        loading={loading}
                                        disabled={loading}
                                        className="w-100 padding-14px-top padding-14px-bottom e-primary-button-hover transition"
                                        onPress={_handleValidateOTP} />
                                </div>
                            </div>
                        </div>
                        :
                        <div className=" modal-content e-bg-lotion e-border-radius-24 e-modal-box-shadow ">
                            <div className="modal-body p-4 e-border-radius-24">
                                <div className="d-flex flex-column align-items-center">
                                    <img src={CloseBtn}
                                        width={32}
                                        draggable={false}
                                        className='cursor-pointer float-end align-self-end'
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        alt='close'
                                        onClick={props.onClose} />
                                    <img className="img-fluid col-2 mt-4 pt-3"
                                        draggable={false}
                                        src={ImportPortfolioSuccess}
                                        alt="payment status image" />
                                    <p className="e-font-14-res text-center e-text-eerie-black e-primary-font-inter e-font-18 e-font-weight-500 mt-4 mb-2">
                                        Importing all external funds
                                    </p>
                                    <p className="e-font-12-res line-height-20px-res col-sm-10 mx-auto text-center e-text-charleston-green e-alt-font-poppins e-font-14 e-font-weight-400 line-height-26px text-center mx-auto mb-0 mb-4">
                                        Funds will appear on your dashboard in 10-15 mins
                                    </p>
                                    <PrimaryButton name="Done"
                                        dismiss="modal"
                                        className="padding-14px-tb w-100"
                                        onPress={_handleRefreshPortfolio} />
                                </div>
                            </div>
                        </div>
                }
            </div>
            {
                externalFundLoader === true &&
                <StatusLoader />
            }
        </div>
    )
}

export default memo(ExternalFundImportModal);


